export const APPLICATION_URL = "https://rsfbackend.ondc.clouddeploy.in/";
export const API_BASE_PATH = "futuresoft/ondc/rsf/api/v2";
export const APP_BASE_URL2 = "https://preprod.appwrapper.clouddeploy.in/route"

export const API_BASE_URL = `${APPLICATION_URL}${API_BASE_PATH}`;

export const endpoint = {
  GET_ANALYTICS_DASHBOARD: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/analytics/dashboard`,
  GET_ORDERS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/orders/getOrders`,
  GET_ORDER_DETAILS :`${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/orders/getOrder/`,
  SEND_SETTLEMENT_REQUEST: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/sendRequest`,
  GET_SETTLEMENTS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlements`,
  GET_SETTLEMENT_DETAILS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementDetailById/`,
  GET_RECONS:  `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/recon/getRecons`,
  RAISE_RECON: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/recon/raiseRecon`,
  GET_FAQS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/support/faqs`,
  RAISE_RECON_ISSUE: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/recon/raiseIssue`,
  GET_RECONS_Detail:  `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/recon/getReconDetailById/`,
  RAISE_REPORT: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/report/raiseReport`,
  GET_REPORTS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/report/getReports`,
  CONTACT_US:`${APP_BASE_URL2}/igm/api/V1/support/contact_us`,
  GET_MISC_SETTLEMENTS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getMiscSettlements`,
  GET_MISC_SETTLEMENT_DETAILS:`${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementMiscDetails/`,
  SEND_MISC_SETTLEMENT_REQUEST: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/sendMiscRequest`,
  GET_SETTLEMENT_DETAILS_REQUEST:`${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementDetails/`,
  GET_PAYOUTS: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/payout/payout-screen`,
  SEND_ON_RECON_REQUEST: `${APP_BASE_URL2}/rsf/futuresoft/ondc/rsf/api/v2/recon/submit-on-recon`,
};
